import { storeToRefs } from 'pinia';

import {
  useSessionViewsStore,
  useSessionViewsGetters,
} from './use-session-views-store';
import { useSessionViewsRouter } from './use-session-views-router';
import { useSessionViewsActions } from './use-session-views-actions';

export { useApplySessionView } from './use-apply-session-view';
export { SessionView, ConversationsFilter, DisplaySettings } from './types';
export { SESSION_VIEW_TYPE } from './constants';

export const useSessionViews = () => {
  return {
    ...storeToRefs(useSessionViewsStore()),
    ...useSessionViewsGetters(),
    ...useSessionViewsRouter(),
    ...useSessionViewsActions(),
  };
};
